import React, { useState, useEffect, useContext } from "react";
import {
  Card,
  CardContent,
  TextField,
  Button,
  makeStyles,
  Container,
  Chip,
  Avatar,
  Paper,
} from "@material-ui/core";
import PaymentOptions from "./PaymentOptions";
import ClientInfoCard from "./ClientInfoCard";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { ArrowBack } from "@material-ui/icons"; // Import the back icon
import { useCart } from "../Context/CartContext";
import { useShift } from "../Context/ShiftContext";
import { StaffCommissionDetailContext } from "../Context/StaffCommissionDetailsContext";
import { initialState } from "../initialState";
import { useSnackbar } from "react-simple-snackbar";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useCurrency } from "../Context/CurrencyContext";
import { useDiscount } from "../Context/DiscountContext";
import {
  createInvoice,
  deleteInvoice,
  getInvoice,
  updateInvoice,
} from "../actions/invoiceActions";
import { updateStaffCommissionDetails } from "../actions/staffCommissionDetailActions";
// import { updateItems } from "../actions/itemActions";
import { getAllClients } from "../actions/clientActions";
import SaveIcon from "@material-ui/icons/Save";
import { usePayNow } from "../Context/PayNowContext";
import { useOrderSession } from "../Context/OrderSessionContext";
import BillDialog from "./BillDialog";
import CardDialog from "./CardDialog";
import { createStock, deleteStockById } from "../actions/stockActions";
import AddClient from "../components/Invoice/AddClient";
import { StockContext } from "../Context/StockContext";
const useStyles = makeStyles((theme) => ({
  card: {
    maxWidth: 600, // Increase the size of the card
    margin: "auto",
    padding: "0 48px",

    boxShadow: "0 4px 8px 0 rgba(0,0,0,1.7)", // Add box shadow
  },
  formControl: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  backButton: {
    position: "absolute",
    top: theme.spacing(17),
    left: theme.spacing(28),
  },
  saveButton: {
    display: "flex",
    justifyContent: "space-around",
  },
}));
const options = {
  position: "bottom",
  style: {
    backgroundColor: "red",
    border: "2px solid red",
    color: "white",
    fontFamily: "Menlo, monospace",
    fontSize: "20px",
    textAlign: "center",
  },
  closeStyle: {
    color: "lightcoral",
    fontSize: "16px",
  },
};
const PaymentDetails = ({ invoiceId }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const {
    cartItems,
    setCartItems,
    getTotalPrice,
    receivedAmount,
    setReceivedAmount,
    calculateChange,
    calculateVat,
    getSubTotalPrice,
    calculateDiscount,
    getInvoiceNumber,
  } = useCart();
  const { myActiveShift } = useShift();
  const { getConvertedQuantity } = useContext(StockContext);
  const { staffCommissionDetailsArray } = useContext(
    StaffCommissionDetailContext
  );
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const { currency, updateCurrency } = useCurrency();
  const [invoiceData, setInvoiceData] = useState(initialState);
  const [openSnackbar, closeSnackbar] = useSnackbar(options);
  const [error, setError] = useState("");
  const { invoice } = useSelector((state) => state.invoices);
  console.log("INvoice in payment details", invoice);
  const user = JSON.parse(localStorage.getItem("profile"));
  const clients = useSelector((state) => state.clients.clients);
  const [client, setClient] = useState(null);
  const [status, setStatus] = useState("");
  const [defaultClient, setDefaultClient] = useState(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const {
    discountFlag,
    clearDiscount,
    discountVal,
    discountType,
    discountRate,
  } = useDiscount();
  const [itemsData, setItemsData] = useState([]);
  const [openBillDialog, setOpenBillDialog] = useState(false);
  const [openCardDialog, setOpenCardDialog] = useState(false);
  const handleBillDialogClose = () => {
    // You can add logic to close the dialog and handle bill printing here
    setOpenBillDialog(false);
  };
  const dispatch = useDispatch();
  const history = useHistory();
  const { handlePayNow } = usePayNow();
  const { activeSessionId, checkoutSession } = useOrderSession();
  useEffect(() => {
    const defaultClient = clients.filter((clt) => clt.name === "Cash");
    console.log("Default Client", defaultClient);
    setDefaultClient(defaultClient[0]);
  }, [clients]);

  useEffect(() => {
    dispatch(
      // getClientsByUser({ search: user?.result._id || user?.result?.googleId })
      getAllClients()
    );
    // dispatch(
    //   // getClientsByUser({ search: user?.result._id || user?.result?.googleId })
    //   getAllSuppliers()
    // );

    // dispatch(
    //   // getItemsByUser({ search: user?.result._id || user?.result?.googleId })
    //   getAllItems()
    // );
    // eslint-disable-next-line
  }, [dispatch]);

  // useEffect(() => {
  //   const transformedItems = cartItems.map((cartItem) => ({
  //     item: cartItem._id, // Extract _id
  //     quantity: cartItem.quantity, // Extract quantity
  //   }));
  //   console.log("useffect run in payment details")
  //   setInvoiceData({ ...invoiceData, items: transformedItems });
  // }, [cartItems,setInvoiceData]);
  useEffect(() => {
    // Whenever formData changes, set hasUnsavedChanges to true
    setHasUnsavedChanges(true);
  }, [invoiceData]);
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        // Display a confirmation message
        e.preventDefault();
        e.returnValue =
          "You have unsaved changes. Are you sure you want to leave this page?";
      }
    };

    // Attach the event listener
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);

  useEffect(() => {
    if (invoice && invoice.items && invoice.items.length > 0) {
      // Extracting _id and name from each item and creating a new array of objects
      const extractedData = invoice.items.map((item) => ({
        _id: item._id,
        quantity: item.quantity,
      }));
      setItemsData(extractedData);
      setInvoiceNumber(invoice.invoiceNumber);
      setInvoiceData(invoice);
      setClient(invoice.client);
    }
  }, [invoice]);
  useEffect(() => {
    if (invoiceData.paymentMode === "Credit") {
      setStatus("Due");
    } else {
      setStatus("Paid");
    }
  }, [invoiceData]);
  useEffect(async () => {
    if (!invoice) {
      const invoiceNo = await getInvoiceNumber();

      setInvoiceNumber(invoiceNo);
    }
  }, []);
  const stockDetailsItems = async (cartItems, invoiceNumber) => {
    // debugger;
    const stockItems = await Promise.all(
      cartItems.map(async (item) => ({
        item: item._id,
        transactionType: "SALES",
        qty: await getConvertedQuantity(item, "sale", null, false) || item.quantity, // No conversion, store 1000 ml
        categoryId: item.category.categoryId,
        invoiceId: invoiceNumber,
        createdAt: new Date(),
        unit: item.units.sale.unit,
        references: {
          invoiceId: invoiceNumber,
          transactionRef: "Invoice",
        },
        creator: user?.result?._id || "65549a5b77d1c64130b5db0c",
      }))
    );

    return stockItems;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const hasEmptyItems = invoiceData.items.some(
      (item) => !item.quantity && !item.paymentMode
    );

    // console.log(hasEmptyItems);
    if (
      hasEmptyItems ||
      // !subTotal ||
      !getTotalPrice ||
      !status

      // !vat ||
      // !rates ||
      //  !currency ||
      // !selectedDate ||
      // !client
      // !signatureDataUrl||
      // !supplier
      // !type ||
    ) {
      openSnackbar("Please fill the details");
      return;
    }
    if (!myActiveShift) {
      openSnackbar("Please start your shift before creating an invoice.");
      return;
    }
    if (invoiceData.paymentMode === "") {
      openSnackbar("Please select the Payment Mode");
      return;
    }
    if (invoiceData.paymentMode === "Cash" && !receivedAmount) {
      openSnackbar("Please fill the Amount");
      return;
    } else if (
      invoiceData.paymentMode === "Cash" &&
      receivedAmount < getTotalPrice()
    ) {
      openSnackbar("Please pay the required amount ");
      return;
    }
    if (invoiceData.paymentMode === "Credit" && (!client || client == null)) {
      openSnackbar("Please select the customer");
      return;
    }
    setError("");

    if (activeSessionId) {
      try {
        const paymentPayload = {
          client: client ? client : defaultClient,
          paymentMode: invoiceData.paymentMode || "Cash",
          discount: discountVal ? parseFloat(discountVal) : 0,
          receivedAmount: invoiceData.paymentMode === "Cash" ? receivedAmount : null,
          change: invoiceData.paymentMode === "Cash" ? calculateChange() : null,
          currency,
          creator: [user?.result?._id || user?.result?.googleId],
          shiftId: myActiveShift?._id ?? null,
          employeeId: myActiveShift?.employeeId ?? null,
          employeeName: myActiveShift?.employeeName ?? null,
        };
        const { invoice: createdInvoice } = await checkoutSession(activeSessionId, paymentPayload);
        setCartItems([]);
        clearDiscount?.();
        handlePayNow?.();
        history.push(`/invoice/${createdInvoice._id}`);
      } catch (err) {
        openSnackbar(err?.response?.data?.message || "Checkout failed");
      }
      return;
    }

    if (invoice) {
      // debugger;
      dispatch(deleteInvoice(invoiceId));

      dispatch(
        createInvoice(
          {
            ...invoiceData,

            items: cartItems.map((cartItem) => {
                  const originalRate =
                    cartItem.originalPrice ??
                    cartItem?.units?.sale?.price ??
                    cartItem?.rate ??
                    0;
                  const effectiveRate =
                    cartItem.overridePrice != null
                      ? parseFloat(cartItem.overridePrice)
                      : originalRate;
                  const priceAdjusted =
                    Math.abs(effectiveRate - originalRate) > 0.0001;
                  return {
                    item: cartItem._id, // Extract _id
                    quantity: cartItem.quantity, // Extract quantity
                    rate: effectiveRate,
                    originalRate,
                    priceAdjusted,
                    remark: (cartItem.remark && String(cartItem.remark).trim()) || null,
                  };
                }),
            subTotal: getSubTotalPrice(),
            total: getTotalPrice(),
            invoiceNumber,
            receivedAmount:
              invoiceData.paymentMode === "Cash" ? receivedAmount : null,
            change:
              invoiceData.paymentMode === "Cash" ? calculateChange() : null,
            vat: calculateVat(),
            discount: discountVal ? discountVal.toFixed(2) : 0,
            // rates: rates,
            currency: currency,
            status: status,
            // dueDate: selectedDate,
            invoiceNumber: invoiceNumber,
            client: client ? client : defaultClient,
            // supplier,
            // signatureDataUrl,
            // type: type,

            // paymentRecords: [],
            creator: [user?.result?._id || user?.result?.googleId],
            shiftId: myActiveShift?._id ?? null,
            employeeId: myActiveShift?.employeeId ?? null,
            employeeName: myActiveShift?.employeeName ?? null,
            createdAt: new Date(),
            isPrintBill: true,
          },
          staffCommissionDetailsArray,
          history
        )
      );
      dispatch(deleteStockById(invoiceNumber, "SALES"));
      console.log("invoiceData items", invoiceData.items);
      console.log(
        "stockDetailsItems",
        stockDetailsItems(invoiceData.items, invoiceNumber)
      );
      dispatch(
        createStock(stockDetailsItems(invoiceData.items, invoiceNumber))
      );
      dispatch(updateStaffCommissionDetails(staffCommissionDetailsArray));
      dispatch(
        createInvoice(
          {
            ...invoiceData,

            items: cartItems.map((cartItem) => {
                  const originalRate =
                    cartItem.originalPrice ??
                    cartItem?.units?.sale?.price ??
                    cartItem?.rate ??
                    0;
                  const effectiveRate =
                    cartItem.overridePrice != null
                      ? parseFloat(cartItem.overridePrice)
                      : originalRate;
                  const priceAdjusted =
                    Math.abs(effectiveRate - originalRate) > 0.0001;
                  return {
                    item: cartItem._id, // Extract _id
                    quantity: cartItem.quantity, // Extract quantity
                    rate: effectiveRate,
                    originalRate,
                    priceAdjusted,
                    remark: (cartItem.remark && String(cartItem.remark).trim()) || null,
                  };
                }),
            subTotal: getSubTotalPrice(),
            total: getTotalPrice(),
            invoiceNumber,
            receivedAmount:
              invoiceData.paymentMode === "Cash" ? receivedAmount : null,
            change:
              invoiceData.paymentMode === "Cash" ? calculateChange() : null,
            vat: calculateVat(),
            discount: discountVal ? discountVal.toFixed(2) : 0,
            // rates: rates,
            currency: currency,
            status: status,
            // dueDate: selectedDate,
            invoiceNumber: invoiceNumber,
            client: client ? client : defaultClient,
            // supplier,
            // signatureDataUrl,
            // type: type,

            // paymentRecords: [],
            creator: [user?.result?._id || user?.result?.googleId],
            shiftId: myActiveShift?._id ?? null,
            employeeId: myActiveShift?.employeeId ?? null,
            employeeName: myActiveShift?.employeeName ?? null,
            createdAt: new Date(),
            isPrintBill: true,
          },
          staffCommissionDetailsArray,
          history
        )
      );
      const stockTransactions = await stockDetailsItems(
        cartItems,
        invoiceNumber
      );
      // debugger;
      dispatch(createStock(stockTransactions));

      history.push(`/invoice/${invoice._id}`);
    } else {
      dispatch(
        createInvoice(
          {
            ...invoiceData,

            items: cartItems.map((cartItem) => {
                  const originalRate =
                    cartItem.originalPrice ??
                    cartItem?.units?.sale?.price ??
                    cartItem?.rate ??
                    0;
                  const effectiveRate =
                    cartItem.overridePrice != null
                      ? parseFloat(cartItem.overridePrice)
                      : originalRate;
                  const priceAdjusted =
                    Math.abs(effectiveRate - originalRate) > 0.0001;
                  return {
                    item: cartItem._id, // Extract _id
                    quantity: cartItem.quantity, // Extract quantity
                    rate: effectiveRate,
                    originalRate,
                    priceAdjusted,
                    remark: (cartItem.remark && String(cartItem.remark).trim()) || null,
                  };
                }),
            subTotal: getSubTotalPrice(),
            total: getTotalPrice(),
            invoiceNumber,
            receivedAmount:
              invoiceData.paymentMode === "Cash" ? receivedAmount : null,
            change:
              invoiceData.paymentMode === "Cash" ? calculateChange() : null,
            vat: calculateVat(),
            discount: discountVal ? discountVal.toFixed(2) : 0,
            // rates: rates,
            currency: currency,
            status: status,
            // dueDate: selectedDate,
            invoiceNumber: invoiceNumber,
            client: client ? client : defaultClient,
            // supplier,
            // signatureDataUrl,
            // type: type,

            // paymentRecords: [],
            creator: [user?.result?._id || user?.result?.googleId],
            shiftId: myActiveShift?._id ?? null,
            employeeId: myActiveShift?.employeeId ?? null,
            employeeName: myActiveShift?.employeeName ?? null,
            createdAt: new Date(),
            isPrintBill: true,
          },
          staffCommissionDetailsArray,
          history
        )
      );
      const stockTransactions = await stockDetailsItems(
        cartItems,
        invoiceNumber
      );
      // debugger;
      dispatch(createStock(stockTransactions));
    }

    setInvoiceData(initialState);
  };
  const handleButton = () => {
    console.log("cartItems", cartItems);

    // const updatedCartItems = cartItems.map(item => {
    //   const quantity = parseFloat(item.quantity);
    //   const initialQty = parseFloat(item.stockQty.initialQty);

    //   // Check if the values are valid numbers before subtraction
    //   if (!isNaN(quantity) && !isNaN(initialQty)) {
    //     return {
    //       ...item,
    //       stockQty: {
    //         ...item.stockQty,
    //         initialQty: initialQty - quantity,
    //       },
    //     };
    //   } else {
    //     // Handle the case where the values are not valid numbers
    //     console.error('Invalid quantity or initialQty:', item);
    //     // You can choose to set a default value or skip updating the item
    //     return item; // or return a default value
    //   }
    // });
    // console.log("updated Items",updatedCartItems)
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "paymentMode") {
      setInvoiceData({
        ...invoiceData,
        [name]: value,
      });
      if (value === "Cash") {
        setOpenBillDialog(true);
      }
      if (value === "Card") {
        setOpenCardDialog(true);
      }
      // Check if "Cash" is selected and set openCashDialog accordingly
    }
  };

  const handleCardPayment = (updatedCardData) => {
    setInvoiceData({ ...invoiceData, card: updatedCardData });
  };
  const CustomPaper = (props) => {
    return <Paper elevation={3} {...props} />;
  };
  const clientsProps = {
    options: clients,
    getOptionLabel: (option) => option.name,
  };
  return (
    <>
      <AddClient setOpen={setOpen} open={open} />
      <Card className={classes.card} elevation={1}>
        <CardContent>
          {/* <IconButton className={classes.backButton} onClick={()=>setOpenBillDialog(!openBillDialog)}>
          <ArrowBack />
        </IconButton> */}
          {/* Your existing form elements */}
          {/* ... */}

          <form onSubmit={handleSubmit}>
            {!openBillDialog && !openCardDialog && (
              <>
                <Container>
                  {client && (
                    <>
                      <ClientInfoCard client={client} setClient={setClient} />
                    </>
                  )}
                  <div
                    style={client ? { display: "none" } : { display: "block" }}
                  >
                    <Autocomplete
                      {...clientsProps}
                      PaperComponent={CustomPaper}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          // required={!invoice && true}
                          label="Select Customer"
                          margin="normal"
                          variant="outlined"
                          style={{ minWidth: 200 }}
                        />
                      )}
                      value={clients?.name}
                      onChange={(event, value) => {
                        setClient(value);
                      }}
                      // onChange={(event, value) => setClient(value) }
                    />
                  </div>
                  {!client && (
                    <>
                      <div style={{ paddingBottom: "10px" }}>
                        <Chip
                          avatar={
                            <Avatar
                              style={{
                                backgroundColor: "#ef7f1a",
                                color: "white",
                              }}
                            >
                              +
                            </Avatar>
                          }
                          label="New Customer"
                          onClick={() => setOpen(true)}
                          variant="outlined"
                        />
                      </div>
                    </>
                  )}
                </Container>

                <Container>
                  <PaymentOptions
                    invoiceData={invoiceData}
                    handleInputChange={handleInputChange}
                  />
                  <div
                    style={{
                      marginTop: 20,
                      marginBottom: 10,
                      fontWeight: "bold",
                      fontSize: "1.35rem",
                      color: "#333",
                      letterSpacing: 1,
                      textAlign: "center",
                    }}
                  >
                    Current Invoice&nbsp;&nbsp;|&nbsp;&nbsp;#{invoiceNumber}
                  </div>
                </Container>
              </>
            )}
            {openBillDialog && (
              <BillDialog
                currency={currency}
                setOpenBillDialog={setOpenBillDialog}
                invoice={invoice}
              />
            )}
            {openCardDialog && (
              <CardDialog
                handleCardPayment={handleCardPayment}
                invoiceData={invoiceData}
                currency={currency}
                setOpenCardDialog={setOpenCardDialog}
              />
            )}
            <div className={classes.saveButton}>
              <Button
                variant="contained"
                style={{
                  justifyContent: "center",
                  backgroundColor: "#ef7f1a",
                  color: "white",
                }}
                type="submit"
                color="primary"
                size="large"
                startIcon={<SaveIcon />}
              >
                {invoice ? "UPDATE" : "Pay Now"}
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </>
  );
};

export default PaymentDetails;
